/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** Auth type */
export type AuthType =
  | 'SESSION'
  | 'TOKEN';

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactSubmissionCreate */
export type ContactSubmissionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactSubmissionInput: ContactSubmissionInput;
};

/** Autogenerated return type of ContactSubmissionCreate. */
export type ContactSubmissionCreatePayload = {
  __typename?: 'ContactSubmissionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  idempotent: Scalars['Boolean']['output'];
  submissionId: Scalars['ID']['output'];
};

export type ContactSubmissionInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CredentialsUserAuth */
export type CredentialsUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CredentialsUserAuth. */
export type CredentialsUserAuthPayload = {
  __typename?: 'CredentialsUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of EmailTokenUserAuth */
export type EmailTokenUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of EmailTokenUserAuth. */
export type EmailTokenUserAuthPayload = {
  __typename?: 'EmailTokenUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailUserAuthChallenge */
export type EmailUserAuthChallengeInput = {
  clientAuthCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of EmailUserAuthChallenge. */
export type EmailUserAuthChallengePayload = {
  __typename?: 'EmailUserAuthChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of FounderSubmissionCreate */
export type FounderSubmissionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  founderSubmissionInput: FounderSubmissionInput;
};

/** Autogenerated return type of FounderSubmissionCreate. */
export type FounderSubmissionCreatePayload = {
  __typename?: 'FounderSubmissionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  courseEnabled: Scalars['Boolean']['output'];
  idempotent: Scalars['Boolean']['output'];
  submissionId: Scalars['ID']['output'];
};

export type FounderSubmissionInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type InternalAdminContactSubmission = {
  __typename?: 'InternalAdminContactSubmission';
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  emailDeliveryStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/** The connection type for InternalAdminContactSubmission. */
export type InternalAdminContactSubmissionConnection = {
  __typename?: 'InternalAdminContactSubmissionConnection';
  /** A list of edges. */
  edges: Array<InternalAdminContactSubmissionEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminContactSubmission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminContactSubmissionEdge = {
  __typename?: 'InternalAdminContactSubmissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminContactSubmission>;
};

export type InternalAdminFounderCourseEnrollment = {
  __typename?: 'InternalAdminFounderCourseEnrollment';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nextSendAt: Scalars['ISO8601DateTime']['output'];
  step: Scalars['Int']['output'];
  unsubscribedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for InternalAdminFounderCourseEnrollment. */
export type InternalAdminFounderCourseEnrollmentConnection = {
  __typename?: 'InternalAdminFounderCourseEnrollmentConnection';
  /** A list of edges. */
  edges: Array<InternalAdminFounderCourseEnrollmentEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminFounderCourseEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminFounderCourseEnrollmentEdge = {
  __typename?: 'InternalAdminFounderCourseEnrollmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminFounderCourseEnrollment>;
};

export type InternalAdminFounderSubmission = {
  __typename?: 'InternalAdminFounderSubmission';
  company: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  emailDeliveryStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/** The connection type for InternalAdminFounderSubmission. */
export type InternalAdminFounderSubmissionConnection = {
  __typename?: 'InternalAdminFounderSubmissionConnection';
  /** A list of edges. */
  edges: Array<InternalAdminFounderSubmissionEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminFounderSubmission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminFounderSubmissionEdge = {
  __typename?: 'InternalAdminFounderSubmissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminFounderSubmission>;
};

export type InternalAdminNewsletterSubscription = {
  __typename?: 'InternalAdminNewsletterSubscription';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  emailDeliveryStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mailchimpLastError?: Maybe<Scalars['String']['output']>;
  mailchimpStatus: Scalars['String']['output'];
  mailchimpSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  source: Scalars['String']['output'];
  unsubscribedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for InternalAdminNewsletterSubscription. */
export type InternalAdminNewsletterSubscriptionConnection = {
  __typename?: 'InternalAdminNewsletterSubscriptionConnection';
  /** A list of edges. */
  edges: Array<InternalAdminNewsletterSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminNewsletterSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminNewsletterSubscriptionEdge = {
  __typename?: 'InternalAdminNewsletterSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminNewsletterSubscription>;
};

/** Autogenerated input type of InternalAdminNewsletterSubscriptionRetryMailchimpSync */
export type InternalAdminNewsletterSubscriptionRetryMailchimpSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminNewsletterSubscriptionRetryMailchimpSync. */
export type InternalAdminNewsletterSubscriptionRetryMailchimpSyncPayload = {
  __typename?: 'InternalAdminNewsletterSubscriptionRetryMailchimpSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newsletterSubscription: InternalAdminNewsletterSubscription;
};

export type InternalAdminSessionSignup = {
  __typename?: 'InternalAdminSessionSignup';
  building?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextSessionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for InternalAdminSessionSignup. */
export type InternalAdminSessionSignupConnection = {
  __typename?: 'InternalAdminSessionSignupConnection';
  /** A list of edges. */
  edges: Array<InternalAdminSessionSignupEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminSessionSignup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminSessionSignupEdge = {
  __typename?: 'InternalAdminSessionSignupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminSessionSignup>;
};

export type InternalAdminUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
  userStatus?: InputMaybe<UserStatus>;
};

/** Autogenerated input type of InternalAdminUserUpdate */
export type InternalAdminUserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userInput: InternalAdminUserInput;
};

/** Autogenerated return type of InternalAdminUserUpdate. */
export type InternalAdminUserUpdatePayload = {
  __typename?: 'InternalAdminUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  contactSubmissionCreate: ContactSubmissionCreatePayload;
  credentialsUserAuth: CredentialsUserAuthPayload;
  /** Authenticate a user with an email token */
  emailTokenUserAuth: EmailTokenUserAuthPayload;
  /** Send an email to the user with a challenge code */
  emailUserAuthChallenge: EmailUserAuthChallengePayload;
  founderSubmissionCreate: FounderSubmissionCreatePayload;
  internalAdminNewsletterSubscriptionRetryMailchimpSync: InternalAdminNewsletterSubscriptionRetryMailchimpSyncPayload;
  /** Updates a user by id */
  internalAdminUserUpdate: InternalAdminUserUpdatePayload;
  logout: LogoutPayload;
  newsletterSubscriptionCreate: NewsletterSubscriptionCreatePayload;
  sessionSignupCreate: SessionSignupCreatePayload;
  /** Updates the current viewer */
  viewerUpdate: ViewerUpdatePayload;
};


export type MutationContactSubmissionCreateArgs = {
  input: ContactSubmissionCreateInput;
};


export type MutationCredentialsUserAuthArgs = {
  input: CredentialsUserAuthInput;
};


export type MutationEmailTokenUserAuthArgs = {
  input: EmailTokenUserAuthInput;
};


export type MutationEmailUserAuthChallengeArgs = {
  input: EmailUserAuthChallengeInput;
};


export type MutationFounderSubmissionCreateArgs = {
  input: FounderSubmissionCreateInput;
};


export type MutationInternalAdminNewsletterSubscriptionRetryMailchimpSyncArgs = {
  input: InternalAdminNewsletterSubscriptionRetryMailchimpSyncInput;
};


export type MutationInternalAdminUserUpdateArgs = {
  input: InternalAdminUserUpdateInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationNewsletterSubscriptionCreateArgs = {
  input: NewsletterSubscriptionCreateInput;
};


export type MutationSessionSignupCreateArgs = {
  input: SessionSignupCreateInput;
};


export type MutationViewerUpdateArgs = {
  input: ViewerUpdateInput;
};

/** Autogenerated input type of NewsletterSubscriptionCreate */
export type NewsletterSubscriptionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newsletterSubscriptionInput: NewsletterSubscriptionInput;
};

/** Autogenerated return type of NewsletterSubscriptionCreate. */
export type NewsletterSubscriptionCreatePayload = {
  __typename?: 'NewsletterSubscriptionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  idempotent: Scalars['Boolean']['output'];
  submissionId: Scalars['ID']['output'];
};

export type NewsletterSubscriptionInput = {
  email: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  internalAdminContactSubmission: InternalAdminContactSubmission;
  internalAdminContactSubmissions: InternalAdminContactSubmissionConnection;
  internalAdminFounderCourseEnrollments: InternalAdminFounderCourseEnrollmentConnection;
  internalAdminFounderCourseEnrollmentsCsv: Scalars['String']['output'];
  internalAdminFounderSubmission: InternalAdminFounderSubmission;
  internalAdminFounderSubmissions: InternalAdminFounderSubmissionConnection;
  internalAdminNewsletterSubscription: InternalAdminNewsletterSubscription;
  internalAdminNewsletterSubscriptions: InternalAdminNewsletterSubscriptionConnection;
  internalAdminNewsletterSubscriptionsCsv: Scalars['String']['output'];
  internalAdminSessionSignups: InternalAdminSessionSignupConnection;
  internalAdminSessionSignupsCsv: Scalars['String']['output'];
  internalAdminUsers: UserConnection;
  nextSessionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  uiAccess: UiAccess;
  viewer?: Maybe<User>;
};


export type QueryInternalAdminContactSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAdminContactSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAdminFounderCourseEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInternalAdminFounderSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAdminFounderSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAdminNewsletterSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAdminNewsletterSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAdminSessionSignupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated input type of SessionSignupCreate */
export type SessionSignupCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sessionSignupInput: SessionSignupInput;
};

/** Autogenerated return type of SessionSignupCreate. */
export type SessionSignupCreatePayload = {
  __typename?: 'SessionSignupCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  idempotent: Scalars['Boolean']['output'];
  signupId: Scalars['ID']['output'];
};

export type SessionSignupInput = {
  building?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referrer?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** UI access permissions for the current user */
export type UiAccess = {
  __typename?: 'UiAccess';
  canInternalAdmin: AuthorizationResult;
};

export type User = Node & {
  __typename?: 'User';
  avatarThumbUrl?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRole: UserRole;
  userStatus: UserStatus;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** User role enum */
export type UserRole =
  | 'DEFAULT'
  | 'SYSTEM_ADMIN';

/** User status enum */
export type UserStatus =
  | 'ACTIVE'
  | 'BLOCKED'
  | 'INVITED';

export type ViewerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ViewerUpdate */
export type ViewerUpdateInput = {
  avatarSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  removeAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  viewerInput: ViewerInput;
};

/** Autogenerated return type of ViewerUpdate. */
export type ViewerUpdatePayload = {
  __typename?: 'ViewerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type CreateContactSubmissionMutationVariables = Exact<{
  input: ContactSubmissionCreateInput;
}>;


export type CreateContactSubmissionMutation = { __typename?: 'Mutation', contactSubmissionCreate: { __typename?: 'ContactSubmissionCreatePayload', submissionId: string, idempotent: boolean } };

export type CreateNewsletterSubscriptionMutationVariables = Exact<{
  input: NewsletterSubscriptionCreateInput;
}>;


export type CreateNewsletterSubscriptionMutation = { __typename?: 'Mutation', newsletterSubscriptionCreate: { __typename?: 'NewsletterSubscriptionCreatePayload', submissionId: string, idempotent: boolean } };

export type CreateFounderSubmissionMutationVariables = Exact<{
  input: FounderSubmissionCreateInput;
}>;


export type CreateFounderSubmissionMutation = { __typename?: 'Mutation', founderSubmissionCreate: { __typename?: 'FounderSubmissionCreatePayload', submissionId: string, idempotent: boolean, courseEnabled: boolean } };

export type SessionScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionScheduleQuery = { __typename?: 'Query', nextSessionAt?: string | null };

export type CreateSessionSignupMutationVariables = Exact<{
  input: SessionSignupCreateInput;
}>;


export type CreateSessionSignupMutation = { __typename?: 'Mutation', sessionSignupCreate: { __typename?: 'SessionSignupCreatePayload', signupId: string, idempotent: boolean } };


export const CreateContactSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContactSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactSubmissionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactSubmissionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissionId"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent"}}]}}]}}]} as unknown as DocumentNode<CreateContactSubmissionMutation, CreateContactSubmissionMutationVariables>;
export const CreateNewsletterSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewsletterSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterSubscriptionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsletterSubscriptionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissionId"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent"}}]}}]}}]} as unknown as DocumentNode<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>;
export const CreateFounderSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFounderSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FounderSubmissionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founderSubmissionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissionId"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent"}},{"kind":"Field","name":{"kind":"Name","value":"courseEnabled"}}]}}]}}]} as unknown as DocumentNode<CreateFounderSubmissionMutation, CreateFounderSubmissionMutationVariables>;
export const SessionScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextSessionAt"}}]}}]} as unknown as DocumentNode<SessionScheduleQuery, SessionScheduleQueryVariables>;
export const CreateSessionSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSessionSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionSignupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionSignupCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupId"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent"}}]}}]}}]} as unknown as DocumentNode<CreateSessionSignupMutation, CreateSessionSignupMutationVariables>;